<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect y="12" width="4" height="4" rx="1" fill="#E60000"/>
    <rect opacity="0.3" x="6" y="7" width="4" height="9" rx="1" fill="white"/>
    <rect opacity="0.3" x="12" width="4" height="16" rx="1" fill="white"/>
</svg>
